import { Directive } from '@angular/core';

@Directive({ selector: '[gusCustomDialogContent]' })
export class CustomDialogContentDirective {}
